import { routes } from 'shared/routes';

/**
 * The basic-flow Get Started path after a location exists: keywords, then prompts
 * (when gated on), then getting-insights. Returns `null` when the user is already
 * on the incomplete Add Prompts step and should stay put.
 */
export const getExpectedBasicFlowOnboardingPath = ({
  hasKeywords,
  hasPrompts,
  canShowPrompts,
  currentPath
}: {
  hasKeywords: boolean;
  hasPrompts: boolean;
  canShowPrompts: boolean;
  currentPath: string;
}) => {
  // Already on the incomplete Add Prompts step — stay. Child `beforeLoad` owns
  // the capability gate for this step.
  if (currentPath.startsWith(routes.addPrompts()) && !hasPrompts) {
    return null;
  }

  if (!hasKeywords) {
    return routes.addKeywords();
  }

  if (canShowPrompts && !hasPrompts) {
    return routes.addPrompts();
  }

  return routes.gettingInsights();
};
